<template>
  <router-view v-slot="{ Component }">
    <transition name="fade" mode="out-in">
      <component :is="Component" />
    </transition>
  </router-view>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'

export default {
  name: 'App',
  computed: {
    ...mapState(['token', 'user'])
  },
  methods: {
    ...mapActions(['fetchCurrentUser']),
    ...mapMutations(['SET_LOCALE'])
  },
  async mounted() {
    // 有 token 时总是从服务器拉取最新的用户信息（积分、余额、头像、preferredLocale 等）
    // 避免使用持久化插件恢复的过期数据
    if (this.token) {
      const u = await this.fetchCurrentUser()
      // 登录用户：若后端有 preferredLocale 且与当前不同，则应用之（这样客服侧就能在商城语言基础上识别用户）
      try {
        if (u && u.preferredLocale && this.$i18n && this.$i18n.locale !== u.preferredLocale) {
          this.$i18n.locale = u.preferredLocale
          this.SET_LOCALE(u.preferredLocale)
          localStorage.setItem('locale', u.preferredLocale)
        }
      } catch (e) { /* 静默失败，不影响主流程 */ }
    }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #1a1a2e;
  background-color: #ffffff;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 24px;
}

@media (max-width: 768px) {
  .container {
    padding: 0 12px;
    max-width: 100vw;
    overflow-x: hidden;
  }
}
</style>
